import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = []
  initialize() {
    this.element['controller'] = this
  }
  connect() {
    this.input = Array.from(
      this.element.querySelectorAll(
        'input[type="text"], input[type="email"], input[type="number"], textarea, select'
      )
    )
    this.wrapper = this.element.querySelector('.input-field')
    this.label = this.element.querySelector('label')
    this.input.map((elem) => {
      elem.addEventListener('focus', () => {
        elem.dataset.isTouched = true
        this.update()
      })
    })
    this.input.map((elem) => {
      elem.addEventListener('blur', () => {
        this.update()
      })
    })
    this.input.map((elem) => {
      const eventType = elem.nodeName === 'SELECT' ? 'change' : 'input'
      elem.addEventListener(eventType, (e) => {
        e.target.dataset.isTouched = true
        this.update()
      })
    })
    this.update(true)
  }
  validateEmail = (email) => {
    return !!String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
  }
  inputHasValue(input) {
    return input?.value || input?.value.trim() || input?.value.trim().length
  }
  update(init) {
    setTimeout(() => {
      const hasInputValue = !!this.input
        .map((elem) => !!this.inputHasValue(elem))
        .filter((hasInputValue) => hasInputValue).length
      const allStates = this.input.map((elem) => {
        let states = {}
        const isValid =
          (elem.type === 'email' && this.validateEmail(elem.value)) || elem.type != 'email'
        const isRequired = elem.hasAttribute('required')
        const isTouched = elem.dataset.isTouched
        console.log(isTouched)
        const state =
          (isRequired && !this.inputHasValue(elem)) || (!!this.inputHasValue(elem) && !isValid)
            ? 'errors'
            : 'valid'
        const isFocused = document.activeElement === elem
        elem.classList.remove('valid', 'errors')
        if (hasInputValue || isFocused || (isRequired && !init)) {
          states.valid = state
          elem.classList.add(state)
          elem.dataset.error = 'Is niet valid'
        }
        if (init || hasInputValue || isFocused) {
          elem.classList.add('touched')
        }
        states.active = hasInputValue || isFocused
        return states
      })
      const allActiveStates = allStates.filter((states) => states.active)
      const allValidStates = allStates.map((states) => states.valid)
      const hasErrors = !!allValidStates.filter((valid) => valid === 'errors').length
      const hasValids = !!allValidStates.filter((valid) => valid === 'valid').length
      this.label?.classList[allActiveStates.length ? 'add' : 'remove']('active')
      this.wrapper?.classList.remove('valid', 'errors')
      if (hasErrors || hasValids) {
        this.wrapper?.classList.add(hasErrors ? 'errors' : 'valid')
      }
    }, 1)
  }
}
